export default {
  'site-name': 'Gifta Blog',
  'site-title': 'Gifta Blog',
  'gifta-site-title': 'Gifta Website',
  'gifta-site-link': 'https://www.gifta.de/',
  'pixa-site-title': 'Pixartprinting Website',
  'pixa-site-link': 'https://www.pixartprinting.de/',
  'load-more-article': 'Weitere Artikel lesen',
  'next-slide': 'Weiter',
  'prev-slide': 'Zurück',
  'next-pagination': 'Nächste',
  'prev-pagination': 'Vorherige',
  'next-article': 'Nächster Artikel',
  'related-articles': 'Verwandte Artikel',
  'back-to-top': 'Nach oben',
  search: 'Search',
  'erase-research': 'Suche löschen',
  close: 'Schließen',
  'newsletter-title': 'Newsletter',
  'newsletter-text':
    'Sii tra i primi ad essere aggiornato <br> sulle novità di Gifta blog.',
  'newsletter-cta': 'Registrieren',
}
